<template>
    <div :class="$options.name" id="navigation">
        <div 
            :class="[
                'logo-wrapper'
            ]"
        >
            <button 
                :class="[
                    'name-logo', 
                    { active: $route.name === 'home' && '' === getActiveRoute() }
                ]"
                @click="goToIntro"
            >
                <brand-logo :color="barsColor" />
            </button>
        </div>
        <template v-if="isMobileSize">
            <div :class="['menu', { '-open': isMenuOpen }]" @click="toggleMenu">
                <div class="bars-container">
                    <div class="bar" :style="{ backgroundColor: barsColor }"></div>
                    <div class="bar" :style="{ backgroundColor: barsColor }"></div>
                    <div class="bar" :style="{ backgroundColor: barsColor }"></div>
                </div>
            </div>
        </template>
        <div class="route-nav" v-else>
            <div 
                class="url-wrapper" 
                v-for="(route, index) in routes" 
                :key="`route-${index}`"
            >
                <a
                    @click="goToRoute(route)"
                    :class="['url', {'-active': route === getActiveRoute() }]"
                    :style="{ color: themeColor }"
                >
                    {{ route }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BrandLogo from '@/components/BrandLogo'
export default {
    name: 'navigation-bar',
    data() {
        return {
            currentSection: 0,
            routes: ['about', 'work', 'contact']
        }
    },
    components: {
        'brand-logo': BrandLogo
    },
    computed: {
        ...mapGetters({
            isMenuOpen: 'isMenuOpen',
            themeColor: 'themeColor',
            getFullpageApi: 'getFullPageApi',
            homePageSections: 'getHomePageSections'
        }),
        colorTheme() {
            return 'about' === this.getActiveRoute() ? '#000' : '#fff'
        },
        barsColor() {
            return this.$route.name === 'home' && !this.isMenuOpen ? '#fff' : 'var(--bg-color)'
        }
    },
    methods: {
        toggleMenu() {
            this.$store.dispatch(
                'toggleMenuOverlay',
                this.isMenuOpen ? false : true
            )
        },
        goToRoute(route) {
            let redirect = route === 'work' ? 
                this.projectsList[0].slug :
                route
            if (this.$route.name === 'home') {
                fullpage_api.moveTo(redirect)
            } else {
                this.$router.push({ name: 'home' })
                this.$store.dispatch('updateSectionClicked', redirect )
            }
        },
        goToIntro() {
            if (this.$route.name !== 'home') {
                this.$router.push({ name: 'home' })
            } else {
                fullpage_api.moveTo('')
            }
        },
        getActiveRoute() {
            let currentSection = this.getFullpageApi ? this.getFullpageApi.getActiveSection().index : 0
            if (currentSection === this.homePageSections.indexOf('about')) {
                return 'about'
            } else if (
                currentSection >= this.homePageSections.indexOf(this.projectsList[0].slug) && 
                currentSection <= this.homePageSections.indexOf(this.projectsList[this.projectsList.length - 1].slug)
            ) {
                return 'work'
            } else if (currentSection === this.homePageSections.indexOf('contact')) {
                return 'contact'
            } else {
                return ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/app.scss';

.navigation-bar {
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    display: flex;
    padding: 0.8rem;
    position: absolute;
    align-items: center;
    height: $headerHeight;
    justify-content: space-between;
    
    @include g-state(tabletUp) {
        height: $headerHeightDesktop;
    }

    @include g-state(tabletUp) {
        position: fixed;
        padding: 0.5rem 1rem;
    }
    .logo-wrapper {
        height: 100%;
        width: 2.5rem;
        text-align: left;
        transition: border 0.3s ease;

        .name-logo {
            width: 100%;
            height: 100%;
            position: relative;
            transition: all 0.5s ease;
            svg {
                width: 100%;
                height: auto;
            }
        }
        .active {
            pointer-events: none;
        }
    }
    .menu {
        width: 1.5rem;
        height: 100%;
        display: flex;
        margin: 0 0 0 0.5rem;
        position: relative;
        align-items: center;
        justify-content: center;

        .bars-container {
            width: 100%;
            .bar {
                width: 100%;
                height: 0.2rem;
                margin-bottom: 0.2rem;
                background-color: #000;
                transition: all 0.3s ease;

                :last-child {
                    margin: 0;
                }
            }
        }
        &.-open {
            .bars-container {
                .bar {
                    margin: 0;
                    position: absolute;
                    &:nth-child(1) {
                        transform: rotate(45deg);
                    }
                    &:nth-child(2) {
                        opacity: 0;
                    }
                    &:nth-child(3) {
                        transform: rotate(-45deg);
                    }
                }
            }
        }
    }
    .route-nav {
        display: flex;
        align-items: center;
        justify-content: center;

        .url-wrapper {
            margin: 0 1rem;
            text-transform: capitalize;
            .-active {
                pointer-events: none;
                text-decoration: line-through;
            }
        }
    }
}
</style>
